import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["en", "sv"],
  defaultLocale: "sv",
  localePrefix: {
    mode: "always",
    prefixes: {
      en: "/en",
      sv: "/sv",
    },
  },
});
